import React from 'react';

import LoadingList from '@components/loadings/LoadingList';
import Paragraph from '@components/texts/Paragraph';
import Address from '@models/Address';
import { formatText } from '@utils/formatters';

import ListBaseItem from './Item/index';

import { Container, Items, Labels, NothingFound, Table } from './styles';

interface IProps {
  bases: Address[];
  loading: boolean;
  showTotal: boolean;
  totalValue?: number;
}

const ListBases: React.FC<IProps> = ({
  bases,
  loading,
  showTotal,
  totalValue,
}) => {
  return (
    <Container>
      <Table>
        <Labels>
          <Paragraph nameColor="black" textAlign="start" fontSize={12}>
            Estado
          </Paragraph>
          <Paragraph nameColor="black" textAlign="start" fontSize={12}>
            Cidade
          </Paragraph>
          <Paragraph nameColor="black" textAlign="start" fontSize={12}>
            Bairro
          </Paragraph>
          <Paragraph nameColor="black" textAlign="start" fontSize={12}>
            Rua
          </Paragraph>
          <Paragraph nameColor="black" textAlign="start" fontSize={12}>
            Número
          </Paragraph>
          <Paragraph nameColor="black" textAlign="start" fontSize={12}>
            Complemento
          </Paragraph>
          <Paragraph nameColor="black" textAlign="start" fontSize={12}>
            CEP
          </Paragraph>
        </Labels>
        <Items>
          {loading ? (
            <LoadingList loading={loading} />
          ) : (
            <>
              {bases?.length === 0 ? (
                <NothingFound>
                  <Paragraph nameColor="black" opacity={0.5}>
                    Nenhuma base foi encontrada.
                  </Paragraph>
                </NothingFound>
              ) : (
                <>
                  {bases?.map(base => (
                    <ListBaseItem key={base.id} base={base} />
                  ))}
                </>
              )}
            </>
          )}
        </Items>
        {!loading && showTotal && (
          <Paragraph
            nameColor="black"
            textAlign="end"
            opacity={0.6}
            fontSize={12}
            style={{ margin: '1.5vh 0 0.5vh', fontWeight: 500 }}
          >
            {totalValue === 1
              ? '1 encontrado'
              : `${formatText.numberSeparatedByThousand(
                  totalValue || 0,
                )} encontrados`}
          </Paragraph>
        )}
      </Table>
    </Container>
  );
};

export default ListBases;
